import { type HTMLAttributes, memo, type ReactNode } from 'react';

import BustsInSilhouette from '@/assets/icons/busts-in-silhouette.svg?react';
import Counterclockwise from '@/assets/icons/counterclockwise-arrows-button.svg?react';
import Handshake from '@/assets/icons/handshake.svg?react';
import { Card } from '@/shared/components/ui/card';

const StatItem = ({
  icon,
  value,
  label,
}: {
  icon: ReactNode;
  value: string;
  label: string;
}) => (
  <div className="flex items-center gap-2">
    <div className="text-cold-300 mb-0.5">{icon}</div>
    <div className="flex items-center gap-2">
      <p className="text-cold-50 text-lg leading-5 font-black">{value}</p>
      <p className="text-cold-300 text-xs leading-none font-normal">{label}</p>
    </div>
  </div>
);

export interface ProfileDetailsGameplaySocialOverviewProps extends HTMLAttributes<HTMLDivElement> {
  totalPartymates: number;
  repeatingPartymates: number;
  partyQueuePercentage: number; // 0-1 (e.g., 0.30 for 30%)
}

export const ProfileDetailsGameplaySocialOverview = memo(
  function ProfileDetailsGameplaySocialOverview(
    props: ProfileDetailsGameplaySocialOverviewProps,
  ) {
    const {
      totalPartymates,
      repeatingPartymates,
      partyQueuePercentage,
      ...rest
    } = props;

    return (
      <Card variant="data" {...rest}>
        <p className="text-sm leading-5 font-bold">Social overview</p>
        <div className="flex flex-col gap-3">
          <StatItem
            icon={<BustsInSilhouette className="size-5" />}
            value={totalPartymates.toString()}
            label="Total party-mates"
          />
          <StatItem
            icon={<Handshake className="size-5" />}
            value={repeatingPartymates.toString()}
            label="Repeating Party-mates"
          />
          <StatItem
            icon={<Counterclockwise className="size-5" />}
            value={`${Math.round(partyQueuePercentage * 100).toString()}%`}
            label="Party Queue Percentage"
          />
        </div>
      </Card>
    );
  },
);
